import { useEffect, useMemo } from "react";
import { DoctorTable } from "./DoctorTable";
import { Clinic, Doctor } from "../../models";
import { useClinicContext, useDoctorContext } from "../../contexts";
import { SelectControl } from "../Common";

interface props {
	clinic: Clinic | undefined;
	setClinic: React.Dispatch<React.SetStateAction<Clinic | undefined>>;
}

export const DoctorStatus = ({ clinic, setClinic }: props) => {
	const { userClinics } = useClinicContext();
	const { faceToFaceDoctors, setRefreshFaceToFaceDoctors } = useDoctorContext();

	useEffect(() => {
		if (!clinic && userClinics && userClinics.length > 0) {
			setClinic(userClinics[0]);
		}
	}, [clinic, setClinic, userClinics]);

	const sortDoctors = (a: Doctor, b: Doctor) => {
		if (a.available && !b.available) {
			return -1;
		}
		if (!a.available && b.available) {
			return 1;
		}
		if (`${a.salutation} ${a.fullName}` < `${b.salutation} ${b.fullName}`) {
			return -1;
		}
		if (`${a.salutation} ${a.fullName}` > `${b.salutation} ${b.fullName}`) {
			return 1;
		}
		return 0;
	};

	const doctors = useMemo(() => {
		if (!clinic) {
			return [];
		}

		return [...(faceToFaceDoctors ?? [])]
			.map((doctor: Doctor) => ({
				...doctor,
				available:
					doctor.available &&
					doctor.doctorInstances.find(
						(di) => di.clinicId === clinic.id && di.faceToFaceActive
					) != null
			}))
			.filter((doctor: Doctor) =>
				doctor.doctorInstances.some((di) => di.clinicId === clinic.id)
			)
			.sort(sortDoctors);
	}, [clinic, faceToFaceDoctors]);

	const clinicOptions = useMemo(
		() =>
			userClinics?.map((clinic) => ({
				value: clinic.id.toString(),
				label: clinic.name
			})),
		[userClinics]
	);

	const handleRefreshDoctors: React.Dispatch<React.SetStateAction<boolean>> = (
		value
	) => {
		setRefreshFaceToFaceDoctors(
			typeof value === "function" ? value(false) : value
		);
	};

	const handleClinicChange = (value: string) => {
		const clinic = userClinics?.find((clinic) => clinic.id === Number(value));
		setClinic(clinic);
	};

	return (
		<>
			<div style={{ width: 300 }}>
				<SelectControl
					id="select-clinic"
					label="Centre"
					value={clinic?.id?.toString() ?? ""}
					options={clinicOptions}
					handleChange={handleClinicChange}
				/>
			</div>
			<div className="flex flex-col py-4 gap-4 ch-lightestgrey-background">
				<div className="ch-clear-background ch-border">
					<DoctorTable
						doctors={doctors}
						clinic={clinic}
						setRefreshDoctors={handleRefreshDoctors}
					/>
				</div>
			</div>
		</>
	);
};
